// Generate random BINGO numbers for a single board
// B: 1-15, I: 16-30, N: 31-45, G: 46-60, O: 61-75
export function generateBingoNumbers() {
  const ranges = {
    B: { min: 1, max: 15 },
    I: { min: 16, max: 30 },
    N: { min: 31, max: 45 },
    G: { min: 46, max: 60 },
    O: { min: 61, max: 75 },
  };

  const board = [];
  const letters = ['B', 'I', 'N', 'G', 'O'];

  letters.forEach((letter, colIndex) => {
    const { min, max } = ranges[letter];
    const available = [];
    for (let i = min; i <= max; i++) {
      available.push(i);
    }
    
    // Shuffle and pick 5 numbers
    const shuffled = available.sort(() => Math.random() - 0.5);
    const column = shuffled.slice(0, 5);
    
    // Add to board
    for (let row = 0; row < 5; row++) {
      if (!board[row]) board[row] = [];
      // Center cell (row 2, col 2) is FREE
      if (row === 2 && colIndex === 2) {
        board[row][colIndex] = 'FREE';
      } else {
        board[row][colIndex] = column[row];
      }
    }
  });

  return board;
}

// Calculate optimal grid layout for boards on template
export function calculateBoardLayout(boardCount, templateWidth, templateHeight) {
  // Find the best arrangement that fits the template
  const aspectRatio = templateWidth / templateHeight;
  
  // Try different column counts to find optimal layout
  let bestCols = 1;
  let bestScore = 0;
  
  for (let cols = 1; cols <= boardCount; cols++) {
    const rows = Math.ceil(boardCount / cols);
    const cellWidth = templateWidth / cols;
    const cellHeight = templateHeight / rows;
    
    // BINGO boards are roughly square, so we want cells as close to square as possible
    const cellAspectRatio = cellWidth / cellHeight;
    const score = 1 - Math.abs(1 - cellAspectRatio);
    
    // Penalize if there are empty cells
    const emptyCells = (cols * rows) - boardCount;
    const adjustedScore = score - (emptyCells * 0.1);
    
    if (adjustedScore > bestScore) {
      bestScore = adjustedScore;
      bestCols = cols;
    }
  }
  
  const cols = bestCols;
  const rows = Math.ceil(boardCount / cols);
  
  return { cols, rows };
}

// Calculate font size to fit text in a given box
export function calculateFitFontSize(text, maxWidth, maxHeight, ctx, fontFamily) {
  let fontSize = maxHeight * 0.8;
  ctx.font = `bold ${fontSize}px ${fontFamily}`;
  
  let metrics = ctx.measureText(text);
  
  // Reduce font size until text fits
  while ((metrics.width > maxWidth * 0.9 || fontSize > maxHeight * 0.8) && fontSize > 4) {
    fontSize -= 1;
    ctx.font = `bold ${fontSize}px ${fontFamily}`;
    metrics = ctx.measureText(text);
  }
  
  return fontSize;
}

// Get contrasting text color for a background
export function getContrastColor(hexColor) {
  // Remove # if present
  const hex = hexColor.replace('#', '');
  
  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}
